import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  linkTo?: string;
  linkLabel?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  linkTo,
  linkLabel,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${
        isCenter ? "md:flex-col md:items-center" : ""
      }`}
    >
      <div className={isCenter ? "text-center" : ""}>
        <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.25em] text-primary-600">
          <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc && (
          <p className={`mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 ${isCenter ? "mx-auto" : ""}`}>
            {desc}
          </p>
        )}
      </div>
      {linkTo && linkLabel && (
        <Link
          to={linkTo}
          className="inline-flex items-center gap-1.5 self-start rounded-full border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 md:self-auto whitespace-nowrap"
        >
          {linkLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}